import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const VNEXT_ANALYSIS_API_VERSION = "1.0";
const getUnifiedApiVersion = () => EnvironmentService.useLatestUnifiedApiVersion() ? "2024-10-01-preview" : "2023-03-31-preview";
const getUnifiedApiVersionPreview = () => EnvironmentService.useLatestUnifiedApiVersion() ? "2024-10-01-preview" : "2024-04-01-preview";
export {
  VNEXT_ANALYSIS_API_VERSION,
  getUnifiedApiVersion,
  getUnifiedApiVersionPreview
};
//# sourceMappingURL=ExpAPIV2.constants.js.map
